<!-- =========================================================================================
    File Name: UserIdentitiVerification.vue
    Description: Identity verification data of user
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
    <div class="mt-2 mb-2">
      <div class="vx-row" v-if="identityVerificationData">
        <div class="vx-col w-full">
          <div class="flex flex-center">
            <vs-chip transparent color="dark">
              <span class="bold text-xs">Verificación de identidad: {{ identityVerificationData.identity_status_str }}</span>
            </vs-chip>
            <vs-button :disabled="!identityVerificationData.url_dashboard" :type="btnConfig.type" :color="btnConfig.color" :size="btnConfig.size" radius class="ml-2" icon-pack="feather" icon="icon-eye" target :href="$sanitizeUrl(identityVerificationData.url_dashboard)"></vs-button>
          </div>
        </div>
      </div>
      <div class="vx-row" v-else>
        <div class="vx-col w-full">
          <div class="flex flex-center">
            <vs-chip transparent color="dark">
              <span class="bold text-xs">Verificación de identidad: Sin registro</span>
            </vs-chip>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import formatHelper from '@components/mixins/formatHelper';
import dateHelper from '@components/mixins/dateHelper';
import userIdentityHelper from "@/helpers/userIdentityHelper";

export default{
  name: 'user-identity-verification',
  props: {
    userId: {
      type:[String, Number],
      required: true
    },
    // Prop para cambiar apariencia de botón.
    btnConfig: {
        type: Object,
        required: false,
        default: () => ({
          color: "dark",
          size: "small",
          type: "filled"
        })
    }
  },
  mixins: [userIdentityHelper,dateHelper, formatHelper],
  data () {
    return {
        identityVerificationData: {
          url_dashboard: null
        }
    }
  },
  async mounted() {
    this.identityVerificationData = await this.getUserIdentity(this.userId);
  }
}
</script>